module.exports = "/_next/static/images/c599c8f278cdea9307c08cdbb956b118-value-proposal.png";